import { Col, Container, Row } from "react-bootstrap";
import arrow_right_circle from "assets/images/arrow_right_circle.svg";
import shield_lock from "assets/images/shield_lock.svg";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import TabContext from "context/TabContext";
import axios from "axios";
import ImportantNoticeJson from "constants/important-notice.json";
import { PrimaryButton } from "components/buttons";
import { convertDateFormat } from "utils";
import moment from "moment";

function ImportantNotice() {
  const navigate = useNavigate();
  const { securityTips } = useContext(TabContext);
  const [, setShowTips] = securityTips;
  const [importantNoticeListLegacy, setImportantNoticeListLegacy] = useState([]);
  const [importantNoticeListCms, setImportantNoticeListCms] = useState([]);

  const handleNavigate = (notice) => {
    navigate(`/important-notice-detail/${notice.slug}`);
  };

  useEffect(() => {
    const fetchImportantNoticeFromSpreadSheet = async () => {
      try {
        const response = await axios.get(
          "https://www.alrajhibank.com.my/assets/contents/important-notice.json"
        );
        const jsonResponse = response.data;
        setImportantNoticeListLegacy(jsonResponse);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    const fetchImportantNoticeFromCMS = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_CMS_BASE_URL}/important-notices?populate=*`,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
            },
          }
        );

        const formatToLegacy = response.data.data.map(notice => {
          return {
            title: notice.header,
            date: moment(notice.date).format("DD MMM YYYY"),
            slug: notice.slug,
            content: notice.contentTemplate,
          }
        });
        setImportantNoticeListCms(formatToLegacy);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchImportantNoticeFromSpreadSheet();
    fetchImportantNoticeFromCMS();
  }, []);

  return (
    <section className="section important-notice">
      <div className="container">
        <div className="text-center">
          <h2 className="fw-bolder">Important Notices</h2>
        </div>
        <div className="pt-5">
          <Container>
            <Row>
              {[...importantNoticeListCms, ...importantNoticeListLegacy]
                .sort((a, b) => moment(b.date).valueOf() - moment(a.date).valueOf())
                .map(
                  (notice, index) =>
                    index < 6 && (
                      <Col
                        key={notice.slug}
                        md="6"
                        data-aos="fade-right"
                        data-aos-delay={`${index + 1}00`}
                      >
                        <div className="item p-2 mx-2 my-3">
                          <div className="number">
                            {`${index + 1}`.padStart(2, "0")}
                          </div>
                          <div className="description">
                            {notice.title}
                            <div className="d-flex flex-column right-col text-end justify-content-between">
                              <span className="date">{notice.date}</span>
                              <img
                                src={arrow_right_circle}
                                width="20"
                                className="align-self-end cursor-pointer"
                                alt="arrow-right"
                                onClick={() => handleNavigate(notice)}
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    )
                )}
            </Row>
          </Container>
          <div className="pt-5 text-center">
            <PrimaryButton
              text="View all"
              onClick={() => navigate("/important-notices")}
            />
          </div>
          <div className="mt-5 pt-5 d-flex flex-row justify-content-center align-items-center gap-2">
            <img width="40" src={shield_lock} alt="shield_lock" />
            <div className="security-tips">
              Beware of fake alrajhi bank Malaysia websites! Follow our security
              tips&nbsp;
              <span
                className="primary-color cursor-pointer text-decoration-underline"
                onClick={() => setShowTips(true)}
              >
                Here
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ImportantNotice;